import { render, staticRenderFns } from "./WorkshopGroupUser.vue?vue&type=template&id=5d24e8e4&scoped=true&"
import script from "./WorkshopGroupUser.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroupUser.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopGroupUser.vue?vue&type=style&index=0&id=5d24e8e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d24e8e4",
  null
  
)

export default component.exports